import { css, svg } from '~/lib/bn-lit-element';
import BinCalendar from './bin-calendar';

class BinCalendarMarkManualFeedMask extends BinCalendar {
  static get styles() {
    return [...BinCalendar.styles, css`
      .mark {
        fill: var(--indigo-60)
      }
    `];
  }

  _renderPoint({ point, height, barWidth }) {
    if (point.levelEntity && point.levelEntity.getSubEntity('https://api.binsentry.com/rel/manual-feed-mask-data')) {
      const x = this.xScale(point.date);
      return svg`
        ${super._renderPoint({ point, height, barWidth })}
        <rect
          x="${x - (barWidth / 2)}"
          y="${height}"
          height="3"
          width="${barWidth}"
          class="mark"
        ></rect>
    `;
    }
    return super._renderPoint({ point, height, barWidth });
  }
}

window.customElements.define('bin-calendar-mark-manual-feed-mask', BinCalendarMarkManualFeedMask);
